module.exports = __webpack_public_path__ + "static/img/not_data_img.bb8d2c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/coupon/not_data_img.png
// module id = IwTs
// module chunks = 0